import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import RequirePopup from './require-popup'
import styled from 'styled-components';
import { requireDataset } from '../../actions/user-action'


export default function Publication(){
  const [publications, setPublications] = useState([])
  const [popup, setPopup] =  useState(false)
  useEffect(()=>{
    fetch(`${process.env.PUBLIC_URL}/data/publications.json`)
      .then((response) => response.text())
      .then(text=>JSON.parse(text.replace(/%PUBLIC_URL%/g,process.env.PUBLIC_URL)))
      .then((pub) => {
        setPublications(pub)
      })
      .catch((error) => {
        console.error(error);
      });
  },[])
  const onPopupClose = (accept) =>{
    const {require} = popup;
    if(accept&&accept[require]){
      requireDataset(accept)
    }
    setPopup(false)
  }
  return (
    <Container id="publications" key={"main"} className="section section-publication">
      {popup&&<RequirePopup key={"popup"} message={popup.message} require={popup.require} perpose={popup.perpose} onClose={onPopupClose}/>}
    <div className="container">
      <Title>Publications</Title>
      <PublicationContainer>
        {
          _.map(publications, (publication, key) => {
            const { name, author, description, conference, remark, image,links, projectURL } = publication;
            return (
              <PublicationCard key={key}>
                <PublicationImage className="card-img-top" src={image} alt="" />
                <PublicationBody>
                  <PublicationTitle target="_blank" rel="noopener noreferrer" href={projectURL}>
                    <h4>{name}</h4>
                  </PublicationTitle>
                  {remark&&<Remark><span class="remark-text">{remark}</span><div className="remark-corner"/></Remark>}
                  <PublicationAuthor><i className="icon icon-ui-users"></i> {author}</PublicationAuthor>
                  {description&&<PublicationDescription>{description}</PublicationDescription>}
                  {conference&&<PublicationConference>
                    {conference.name}&nbsp;<strong>{conference.title}</strong>&nbsp;{conference.location}
                  </PublicationConference>}
                </PublicationBody>
                <PublicationFooter>
                    { _.map(links,(_link, label)=>{

                      if(typeof _link === 'string'){
                        return (<a key={label} target="_blank" rel="noopener noreferrer" className="button" href={_link}>
                                  {label}
                                </a>)
                      }
                      else if(_link.require){
                        const { require, message,perpose} = _link;
                        return (<button type="button"  className="button" key={label} onClick={()=>setPopup({require, message,perpose})}>
                                    {label}
                                </button>)
                      }
                      return null;
                    }) }
                </PublicationFooter>
              </PublicationCard>
              )
          })
        }
      </PublicationContainer>
    </div>
  </Container>
  )
}

const Container = styled.section`
  padding-top: 32px;
  padding-bottom: 32px;
  background-color: rgba(var(--background),0.8);
`;
const Title = styled.h2`
font-family: 'Concert One';
`
const PublicationContainer = styled.div`
  margin-top: 24px;
  display: grid;  
  gap: 16px;  
`

const PublicationCard = styled.div`
  background: white;
  padding:24px;
  border-radius: 24px;
  box-shadow: 0 0 24px white;
  position: relative;
  display: grid;
  gap: 16px;  
  box-sizing: border-box;
  grid-template-rows: 256px auto;
  box-shadow: -6px -6px 10px rgba(255, 255, 255, 0.8),
              6px 6px 10px rgba(0, 0, 0, 0.2);

  @media (min-width: 768px) {
    grid-template-rows: none;
    grid-template-columns: 256px auto;
    height: 256px;
  }
`

const PublicationTitle = styled.a`
  grid-area: title;

  & h4{
    font-family: 'Concert One';
  }
`
const PublicationAuthor = styled.div`
  color: var(--primary-color);
`;
const PublicationDescription = styled.p`
  color: var(--text-color);
  text-align: justify;
`
const PublicationImage = styled.img`
  border-radius: 8px 8px 0 0;
  height: calc(100% - 48px);
  object-fit: contain;

`
const PublicationBody = styled.div`

`

const Remark = styled.div`
box-sizing: border-box;
  margin: 0;
  font-size: 20px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum","tnum";
  position: absolute;
  height: 32px;
  padding: 0 16px;
  line-height: 30px;
  white-space: nowrap;
  border-radius: 2px;
  right: -8px;
  top: 64px;
  border-bottom-right-radius: 0;
  color:  var(--assent-color);
  background: var(--assent-color);

  & .remark-text {
    color: #fff;
  }

  & .remark-corner {
    position: absolute;
    top: 100%;
    right: 0;
    width: 8px;
    height: 8px;
    color: currentcolor;
    border: 4px solid;
    transform-origin: top;
    border-color: currentcolor transparent transparent currentcolor;

    &:after{
      position: absolute;
      top: -4px;
      left: -4px;
      width: inherit;
      height: inherit;
      color: rgba(0,0,0,.25);
      border: inherit;
      content: "";
    }
  }
`;
const PublicationConference = styled.p`
  text-align: left;
`

const PublicationFooter = styled.div`

  display: flex;
  gap: 8px;
  justify-content: flex-end;

  & .button,
  & button {
    background-color:  var(--assent-color);
    color: white;
    text-decoration: none!important;
    padding: 4px 16px 4px 16px;
    height: 32px;
    line-height: 24px;
    font-size: 18px;
    border-radius: 24px;
    box-shadow: 6px 6px 18px rgba(var(--assent-color-rgb), .8),
                -6px -6px 14px rgba(255, 255, 255, .8);
    &:hover {
      box-shadow: 6px 6px 18px rgba(var(--assent-color-rgb), .8),
                -6px -6px 14px rgba(255, 255, 255, .8);
    }
    & + & {
      margin-left: 8px;
    }
  }
`